import React, { useEffect, useState, useContext } from "react";

import LocalizationContext from "../LocalizationContext";
import CustomizationContext from "../CustomizationContext";

import Grid from "@mui/material/Grid";
import Button from '@mui/material/Button';
import DirectionsBoatFilledIcon from '@mui/icons-material/DirectionsBoatFilled';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import Avatar from '@mui/material/Avatar';


export const Mood = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [viewMode, setViewMode] = useState(props.viewMode);

    const localizationCtx = useContext(LocalizationContext);
    const customizationCtx = useContext(CustomizationContext);

    const mood001 = customizationCtx.customizationData.rootImages + "Mood_001.jpg";
    const mood002 = customizationCtx.customizationData.rootImages + "Mood_002.jpg";

    const handleSelectMood = async (style) => {
        let currentCustomization = customizationCtx.customizationData;
        currentCustomization.moodType = style;

        const response = await fetch("/api/customization/update", {
            method: 'POST',
            body: JSON.stringify(currentCustomization),
            headers: { 'Content-Type': 'application/json' }
        });

        if (response.ok) {
            const data = await response.json();
            if (data) {
                props.feedbackCallback("config-success", localizationCtx.localizationData.alertUpdated, true);
                props.callBack(0, window.scrollY);
            } else {
                props.feedbackCallback("error", "Error updating configuration", true);
            }

        } else {
            const error = await response.text();
            console.log(error);
            props.feedbackCallback("error", error, true);
        }
    }

    const getMoodDescription = (mood) => {
        if (mood === "Classic") {
            return localizationCtx.localizationData.moodClassicDescription;
        }

        if (mood === "Contemporary") {
            return localizationCtx.localizationData.moodContemporaryDescription;
        }
    }


    return (
        <>
            {viewMode === "conf" &&
                <div className="row">
                    <div className="col-6 text-center">
                        <img src={mood001} alt="Classic" className="image-mood-infynito" /><br />
                        {customizationCtx.customizationData.moodType === "Classic" && <p className="flat-white-button text-uppercase button-infynito-active mt-5">Classic <CheckCircleOutlineRoundedIcon style={{color: 'white'}} /></p>}
                        {customizationCtx.customizationData.moodType !== "Classic" && <a className="flat-gray-button text-uppercase button-infynito-notactive mt-5" onClick={() => handleSelectMood("Classic")}>Classic</a>}
                    </div>
                    <div className="col-6 text-center">
                        <img src={mood002} alt="Contemporary" className="image-mood-infynito" /><br />
                        {customizationCtx.customizationData.moodType === "Contemporary" && <p className="flat-white-button text-uppercase button-infynito-active mt-5">Contemporary <CheckCircleOutlineRoundedIcon style={{ color: 'white' }} /></p>}
                        {customizationCtx.customizationData.moodType !== "Contemporary" && <a className="flat-gray-button text-uppercase button-infynito-notactive mt-5" onClick={() => handleSelectMood("Contemporary")}>Contemporary</a>}
                    </div>
                </div>
            }

            {viewMode === "recap" &&
                <>
                <p className="deck-title-recap">{localizationCtx.localizationData.interior}</p>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-10">
                                <div className="row align-items-center pb-2">
                                    <div className="col-4 text-center">
                                        {customizationCtx.customizationData.moodType === "Classic" && <img src={mood001} className="w-optional-static" alt={customizationCtx.customizationData.moodType} />}
                                        {customizationCtx.customizationData.moodType === "Contemporary" && <img src={mood002} className="w-optional-static" alt={customizationCtx.customizationData.moodType} />}
                                    </div>
                                    <div className="col-8 text-start">
                                        <p className="text-optional pb-3">{customizationCtx.customizationData.moodType}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }

            {viewMode === "summary" &&
                <>
                    <div className="row py-5">
                        <div className="col-12 text-center">
                            <div className="row">
                                <div className="col-8">
                                    {customizationCtx.customizationData.moodType === "Classic" && <img src={mood001} alt="Classic" className="image-mood-infynito" />}
                                    {customizationCtx.customizationData.moodType === "Contemporary" && <img src={mood002} alt="Contemporary" className="image-mood-infynito" />}
                                </div>
                                <div className="col-4 text-start">
                                <p className="deck-title-recap pb-3">{localizationCtx.localizationData.interior}</p>
                                    <List sx={{ width: '100%' }}>
                                        <ListItem key="mood">
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <DirectionsBoatFilledIcon style={{ color: '#00303C' }} />
                                                </Avatar>
                                            </ListItemAvatar>
                                        <ListItemText primary={customizationCtx.customizationData.moodType} secondary={getMoodDescription(customizationCtx.customizationData.moodType)} />
                                        </ListItem>
                                    </List>
                                </div>
                            </div>
                        </div>
                    </div>
                </>

            }
        </>
    );
};

export default Mood;
